import React, { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV2";
import { TextField, Grid } from "@mui/material";
import { TR_REJECT_QUESTION_IDS } from "../../../configs/client-config";
import { parse, isValid as isValidDate } from "date-fns";
const useStyles = makeStyles()((theme) => ({
  backdrop: {
    zIndex: 2,
    color: "white",
  },
  verticalcenter: {
    display: "flex",
    flexDirection: "column",
  },
  descriptionParent: {
    display: "flex",
  },

  descriptionIndex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flexBasis: "3%",
    "@media(max-width: 900px)": {
      flexBasis: "3%",
    },
    "@media(max-width: 600px)": {
      flexBasis: "10%",
    },
    "@media(max-width: 400px)": {
      flexBasis: "15%",
    },
  },
  descriptionDetails: {
    flexBasis: "97%",
    textAlign: "justify",
    "@media(max-width: 900px)": {
      flexBasis: "95%",
    },
    "@media(max-width: 600px)": {
      flexBasis: "90%",
    },
    "@media(max-width: 400p6x)": {
      flexBasis: "85%",
    },
  },
  datePicker: {
    width: "100%",
  },
}));

const SubQuestionDetails = (props) => {
  const { classes } = useStyles();
  const question = props.question;
  const subQuestion = props.subQuestion;

  const [fieldChanged, setFieldChanged] = useState(false);
  const [descAnswer, setDescriptionAnswer] = useState("");
  const parseStoredDate = (answer) => {
    if (!answer) return null;
    const d = parse(answer, "dd/MM/yyyy", new Date());
    return isValidDate(d) ? d : null;
  };

  const [selectedDate, setSelectedDate] = React.useState(
    parseStoredDate(props.answer?.[0]?.answer)
  );

  const storedAnswerValue = props.answer?.[0]?.answer ?? null;

  useEffect(() => {
    if (storedAnswerValue) {
      setDescriptionAnswer(storedAnswerValue);
    }
    const parsedDate = parseStoredDate(storedAnswerValue);
    setSelectedDate(parsedDate);
    if (subQuestion.description === "Date of last sale" && !parsedDate) {
      props.dateCallback(subQuestion.subQuestionId, null, false);
    }
  }, [storedAnswerValue]);

  // Handle Text Inputs
  const handleFormChange = (subQuestionId) => (event) => {
    setDescriptionAnswer(event.target.value);
    setFieldChanged(true);

    // if(validateField2(event.target.value)===""){
    props.parentCallback(subQuestionId, event.target.value, true);
    // }
    // else{
    //     props.parentCallback(subQuestionId, event.target.value, false)
    // }
  };

  const handleDateChange = (date) => {
    const parsed = date ? new Date(date) : null;
    const newDate = parsed && isValidDate(parsed) ? parsed : null;
    setSelectedDate(newDate);
    props.dateCallback(subQuestion.subQuestionId, newDate, newDate !== null);
  };

  // Validation Function to show Errors in the Form UI
  const validateField = (date) => {
    // If form is submitted and inputs are empty
    if (props.isSubmitted && descAnswer === "" && subQuestion.answerRequired) {
      return "Required";
    } else if (props.isDrafted && descAnswer === "" && subQuestion.subQuestionId === 29) {
      return "Required";
    } else if (props.isDrafted && descAnswer === "" && subQuestion.subQuestionId === 39) {
      return "Required";
    } else if (props.isDrafted && descAnswer === "" && subQuestion.subQuestionId === 40) {
      return "Required";
    } else if (props.isDrafted && descAnswer === "" && subQuestion.subQuestionId === 41) {
      return "Required";
    } else if (props.isDrafted && !selectedDate && subQuestion.subQuestionId === 33) {
      return "Required";
    } else if (props.isSubmitted && !selectedDate && subQuestion.subQuestionId === 33) {
      return "Required";
    }
    // When field is empty and not yet submitted
    else if (!props.isSubmitted && descAnswer === "") {
      return "";
    }

    // When field is empty and not yet drafted
    else if (!props.isDrafted && descAnswer === "") {
      return "";
    }
    // There's an input entered
    else {
      // There's a regex to be matched
      if (subQuestion.validationRegex !== "") {
        // If regex is matching with the input
        const regex = RegExp(subQuestion.validationRegex);

        // If form is a drafted form and returning no error
        if (props.answer && props.answer[0] && props.answer[0].descriptionAnswer && !fieldChanged) {
          return "";
        } else {
          if (regex.test(descAnswer)) {
            return "";
          }
          // If regex is not matching with the input
          else {
            // Returning error message to be displayed
            let ret = "Invalid Input";
            if (question.description !== "") {
              ret = "Please enter a valid " + question.questionDescription;
            }
            if (subQuestion.description !== "") {
              ret = "Please enter a valid " + subQuestion.description;
            }
            return ret;
          }
        }
      }
      // There's no regex to be matched
      else {
        return "";
      }
    }
  };

  // Validate Function to returning errors for parent Component
  const validateField2 = (answer) => {
    // When the form initializes, all the fields are valid
    if (!props.isSubmitted && !answer === "") {
      return "";
    }
    // If input is Empty after clicking on the field
    else if (answer === "") {
      return "Required";
    }
    // If form is submitted and inputs are empty
    else if (props.isSubmitted && !answer === "") {
      return "Required";
    }
    // There's an input entered
    else {
      // There's a regex to be matched
      if (subQuestion.validationRegex !== "") {
        // If regex is matching with the input
        const regex = RegExp(subQuestion.validationRegex);
        if (regex.test(answer)) {
          return "";
        }
        // If regex is not matching with the input
        else {
          // Returning error message to be displayed
          let ret = "Invalid Input";
          if (question.description !== "") {
            ret = "Please enter a valid " + question.questionDescription;
          }
          if (subQuestion.description !== "") {
            ret = "Please enter a valid " + subQuestion.description;
          }
          return ret;
        }
      }
      // There's no regex to be matched
      else {
        return "";
      }
    }
  };

  const getRenderBreakpoint = (id) => {
    let subQuestionIdList = [32, 33, 34, 35, 36, 37];
    if (subQuestionIdList.includes(id)) {
      return 6;
    } else {
      return 12;
    }
  };

  return (
    <Grid item xs={12} lg={getRenderBreakpoint(subQuestion.subQuestionId)} className={classes.verticalcenter}>
      {/* Render Description Inputs */}
      {question.questionId === subQuestion.questionId && subQuestion.answerDescription && (
        <div className={classes.descriptionParent}>
          <TextField
            name={subQuestion.subQuestionId + ""}
            size="small"
            onChange={handleFormChange(subQuestion.subQuestionId)}
            label={subQuestion.description}
            autoComplete="nope"
            value={props.answer && props.answer[0] ? props.answer[0].answer : ""}
            error={validateField() !== ""}
            helperText={validateField()}
            variant="outlined"
            disabled={props.formCompleted}
            fullWidth
            multiline={question.questionId === TR_REJECT_QUESTION_IDS?.[0]}
            minRows={question.questionId === TR_REJECT_QUESTION_IDS?.[0] ? 3 : undefined}
          />
        </div>
      )}

      {question.questionId === subQuestion.questionId && subQuestion.description === "Date of last sale" && (
        <div className={classes.datePicker}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label={subQuestion.description}
              value={selectedDate}
              onChange={handleDateChange}
              format="MM/dd/yyyy"
              maxDate={new Date()}
              disabled={props.formCompleted}
              slotProps={{
                textField: {
                  id: "date-picker-dialog",
                  fullWidth: true,
                  size: "small",
                  variant: "outlined",
                  margin: "normal",
                  error: validateField() !== "",
                  helperText: validateField() || "mm/dd/yyyy",
                },
              }}
            />
          </LocalizationProvider>
        </div>
      )}
    </Grid>
  );
};

export default SubQuestionDetails;
